import { StatusBanner } from "@homebound/beam";
import { ReactNode } from "react";
import { PlanPackageAiProposalWorkflow } from "src/generated/graphqlTypes";
import { AiProposalFailureBanner_AiProposalFragment } from "src/routes/libraries/plan-package-v2/components/AiProposalFailureBanner.generated";

type AiProposalFailureBannerProps = {
  proposal: AiProposalFailureBanner_AiProposalFragment;
  onTryAgain: () => void;
  tryAgainDisabled?: boolean | ReactNode;
};

export function AiProposalFailureBanner(props: AiProposalFailureBannerProps) {
  const { proposal, onTryAgain, tryAgainDisabled } = props;
  return (
    <StatusBanner
      type="error"
      icon="error"
      title={proposal.workflow ? titles[proposal.workflow.code] : "AI processing couldn't be completed"}
      description={proposal.failureReason ?? "Something went wrong."}
      primaryAction={{ label: "Try Again", disabled: tryAgainDisabled, onClick: onTryAgain }}
    />
  );
}

const titles: Record<PlanPackageAiProposalWorkflow, string> = {
  [PlanPackageAiProposalWorkflow.ConstructionDocumentExtraction]: "Document import couldn't be completed",
  [PlanPackageAiProposalWorkflow.GenerateTakeoff]: "Takeoff generation couldn't be completed",
};
